export const GET_ALL_OBSERVATIONS = "GET_ALL_OBSERVATIONS";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_OBSERVATIONS = "START_LOADING_OBSERVATIONS";
export const STOP_LOADING_OBSERVATIONS = "STOP_LOADING_OBSERVATIONS";
export const ERROR_LOADING_OBSERVATIONS = "ERROR_LOADING_OBSERVATIONS";